import { render, staticRenderFns } from "./temp_alarm_threshold.vue?vue&type=template&id=072dfbde"
import script from "./temp_alarm_threshold.vue?vue&type=script&lang=js"
export * from "./temp_alarm_threshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports